import React from "react";
import { Link } from "react-router-dom";
import { formatToDate } from "../../master/FormatToDateTime";
import usePrivateLink from "../../config/usePrivateLink";
import Swal from "sweetalert2";
import { studentFeeTransactionDelete } from "../../../api/Student";
import { SweetAlertShow } from "../../master/Master";

export default function FeeTransactions({
  data,
  setLoading,
  handleFunction = () => {},
}) {
  const hasAccess = usePrivateLink();
  const parseModule = (moduleStr) => {
    try {
      const parsed = JSON.parse(moduleStr);
      return parsed.map((m, i) => (
        <div key={i} className="text-nowrap">
          <strong>{m.type}</strong> - ₹{m.amount}
        </div>
      ));
    } catch (e) {
      return "Invalid Data";
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This Transaction will be permanently deleted. You cannot undo this action.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const response = await studentFeeTransactionDelete(id);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
      handleFunction();
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12 mb-3">
          <div className="card">
            <div className="card-body p-2">
              <h5>💳 Transactions</h5>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Receipt</th>
                      <th>Module</th>
                      <th>Amount</th>
                      <th>Payment</th>
                      <th>Bank</th>
                      <th>Date</th>
                      <th>Created By</th>
                      <th>Remark</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.transactions?.length > 0 ? (
                      data?.transactions.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.receipt_no}</td>
                          <td>{parseModule(item.module)}</td>
                          <td className="fw-bold text-success">
                            ₹{item.amount}
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                item.payment_method === "Cash"
                                  ? "bg-success"
                                  : "bg-primary"
                              }`}
                            >
                              {item.payment_method}
                            </span>
                          </td>
                          <td>{item.bank ? item.bank.account_no : "-"}</td>
                          <td>{formatToDate(item.payment_date)}</td>
                          <td>{item.created_by?.name || "-"}</td>
                          <td>{item.remark || "-"}</td>
                          <td>
                            <div className="d-flex gap-2">
                              {hasAccess("/student/fees/receipt") && (
                                <Link
                                  className="btn btn-label-primary"
                                  to={`/student/fees/receipt?id=${item?.id}`}
                                >
                                  <i className="ri-printer-line ri-20px"></i>
                                </Link>
                              )}
                              {hasAccess("/student/fee/transaction/delete") && (
                                <button
                                  className="btn btn-label-danger"
                                  onClick={() => handleDelete(item?.id)}
                                >
                                  <i className="ri-delete-bin-line ri-20px"></i>
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No Transactions Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
